import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { ScheduleCalendarElement } from '@libs/store';
import { TranslateModule } from '@ngx-translate/core';
import { AppointmentStatusCode } from '@ffd/api-client';
import { CdkMenuModule } from '@angular/cdk/menu';
import { DynamicRouterLinkDirective, PushTagOnClickDirective, TagEvent } from '@libs/shared-services';
import { getStatusColorHex, getStatusTextColor, getStatusAbbreviation } from '../appointment-status-chip';

@Component({
  selector: 'lib-appointment-context-menu',
  templateUrl: './appointment-context-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, SvgIconComponent, TranslateModule, CommonModule, CdkMenuModule, DynamicRouterLinkDirective, PushTagOnClickDirective],
})
export class AppointmentContextMenuComponent {
  @Input({ required: true }) public vm!: ScheduleCalendarElement;
  @Input() public statusOptions: AppointmentStatusCode[] = [];
  @Input() public areTreatmentsLoaded: boolean = false;

  @ViewChild('appointmentContextMenu', { static: true }) public appointmentContextMenu!: TemplateRef<unknown>;

  @Output() public setComplete = new EventEmitter<void>();
  @Output() public editStatus = new EventEmitter<void>();
  @Output() public editAppointment = new EventEmitter<void>();
  @Output() public deleteAppointment = new EventEmitter<void>();
  @Output() public openHealthHistory = new EventEmitter<void>();
  @Output() public changeStatus = new EventEmitter<number>();

  protected TagEvent = TagEvent;

  public onSetComplete(): void {
    this.setComplete.emit();
  }

  public onEditStatus(): void {
    this.editStatus.emit();
  }

  public onEditAppointment(): void {
    this.editAppointment.emit();
  }

  public onDeleteAppointment(): void {
    this.deleteAppointment.emit();
  }

  public onOpenHealthHistory(): void {
    this.openHealthHistory.emit();
  }

  public onChangeStatus(statusId: number): void {
    this.changeStatus.emit(statusId);
  }

  public getStatusBackgroundColor(status: AppointmentStatusCode): string {
    return getStatusColorHex(status.statusColor) || '#ffffff';
  }

  public getStatusTextColor(status: AppointmentStatusCode): string {
    return getStatusTextColor(status.statusColor);
  }

  public getStatusCode(status: AppointmentStatusCode): string {
    return getStatusAbbreviation(status.statusColor);
  }
}
